export const ActionUrlExample = 'Example: /ture/egipat?from=1872&to=10';
